<template>
  <v-card flat :class="['product-card', isMobile ? 'mcat-card' : '']" @click="navigate">
    <v-img
      :src="image"
      :lazy-src="lazy"
      :alt="brand.slug || brand.name"
      :height="isMobile ? 175 : 300"
      contain
      class="brand-item-img"
    ></v-img>

    <div style="padding: 1rem;">
      <v-row>
        <v-col class="vc">
          <h4><b>{{ brand.name }}</b></h4>
        </v-col>
        <v-col cols="3" class="vc text-center">
          <v-btn fab outlined x-small color="primary"><v-icon>mdi-chevron-right</v-icon></v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import Store from '../../services/store';

export default {
  name: 'BrandItem',

  props: [
    'grid',
    'brand',
    'iheight'
  ],

  methods: {
    getAssetURL(data) {
      return Store.getAssetURL(data);
    },

    getOriginalAssetURL(data, sid) {
      return Store.getOriginalAssetURL(data, sid);
    },

    navigate() {
      this.$router.push({
        name: 'brand',
        params: { slug: this.brand.slug || this.brand._id },
      }).catch(() => {});
    },
  },

  computed: {
    image() {
      if (!this.brand || !this.brand.file) return this.lazy;
      return this.getOriginalAssetURL(this.brand.file, this.brand.store);
    },

    isMobile() {
      return this.$store.state.isMobile;
    }
  },

  data() {
    return {
      lazy: require("@/assets/imgs/placeholder.png"),
    }
  }
}
</script>

<style scoped>
.brand-item-img {
  background: #f5f5f5;
}
</style>
